import React from 'react';
import MainLayout from '../Layout/MainLayout';

const ExperiencesViewAll = () => {
  return (
    <>
      <MainLayout>
        <div className="event-card-list">
          <div className="container">
            <div className="exp-all pb-4">
              <h4 className="event-mane-heading mb-0">All Experiences</h4>
              <div className="filer-listing">
                <div className="filer-listing-search">
                  <i className="fa fa-search" aria-hidden="true"></i>
                  <input
                    type="search"
                    className="form-control discount-input"
                    placeholder="Search"
                  />
                </div>
                <select
                  id="state_"
                  className="form-select input-outline select-miles mb-0"
                  name="miles"
                  required=""
                  style={{ width: '200px' }}
                >
                  <option value="$200">$ 200</option>
                  <option value="$100">$ 100</option>
                  <option value="$50">$ 50</option>
                  <option value="$20">$ 20</option>
                </select>
                <p className="mb-0">
                  Sort bt : Date
                  <img
                    src="../images/sort.svg"
                    alt="sort"
                    style={{ width: '17px' }}
                  />
                </p>
              </div>
            </div>
            <div className="grid-set-card">
              <div className="card mb-0">
                <img
                  src="../images/about-banner.jpg"
                  alt="event-1"
                  className="img-fluid img-card-shot"
                />

                <div className="card-body">
                  <h4 className="card-heading">
                    INTERACTIVE DEMO IDEAS FOR TRADE SHOWS: TAILORING TO EVERY
                    BUDGET AND SPACE
                  </h4>
                  <div className="">
                    <p
                      className="card-text mb-0 pb-2 d-flex align-items-center gap-2"
                      style={{ color: 'rgba(0, 0, 0, 0.6)' }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="#00000099"
                        version="1.1"
                        id="Capa_1"
                        width="17px"
                        height="17px"
                        viewBox="0 0 395.71 395.71"
                        xmlSpace="preserve"
                      >
                        <g>
                          <path d="M197.849,0C122.131,0,60.531,61.609,60.531,137.329c0,72.887,124.591,243.177,129.896,250.388l4.951,6.738   c0.579,0.792,1.501,1.255,2.471,1.255c0.985,0,1.901-0.463,2.486-1.255l4.948-6.738c5.308-7.211,129.896-177.501,129.896-250.388   C335.179,61.609,273.569,0,197.849,0z M197.849,88.138c27.13,0,49.191,22.062,49.191,49.191c0,27.115-22.062,49.191-49.191,49.191   c-27.114,0-49.191-22.076-49.191-49.191C148.658,110.2,170.734,88.138,197.849,88.138z" />
                        </g>
                      </svg>
                      Wellness Center, Downtown
                    </p>
                    <p
                      className="card-text mb-0 pb-2 d-flex align-items-center gap-2"
                      style={{ color: 'rgba(0, 0, 0, 0.6)' }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17px"
                        height="17px"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M12 7V12L10.5 14.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                          stroke="#00000099"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      March 15, 2025, 7:00 PM
                    </p>
                    <p
                      className="card-text mb-0  d-flex align-items-center gap-2"
                      style={{ color: 'rgba(0, 0, 0, 0.8)' }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17px"
                        height="17px"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <circle
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="#00000099"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M12 6V18"
                          stroke="#00000099"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                        <path
                          d="M15 9.5C15 8.11929 13.6569 7 12 7C10.3431 7 9 8.11929 9 9.5C9 10.8807 10.3431 12 12 12C13.6569 12 15 13.1193 15 14.5C15 15.8807 13.6569 17 12 17C10.3431 17 9 15.8807 9 14.5"
                          stroke="#00000099"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                      </svg>
                      20.99 - 39.99
                    </p>
                  </div>
                  <hr />
                  <p className="card-text mb-0">
                    Cost-Effective Solutions: Engage without Breaking the Bank1.
                    DIY Touch Points: $50-$200 Space Requirement: Minimal - can
                    be integrated into existing booth walls or ...
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MainLayout>
    </>
  );
};

export default ExperiencesViewAll;
